import { Paper } from '@mui/material';
import Tooltip from './BinTooltip';
import React from 'react';
import styles from './box-layout.styles';
import { Component } from 'react';
import { withStyles } from '@mui/styles';
import './index.css';
import { withTranslation } from 'react-i18next';
import LockIcon from '@mui/icons-material/Lock';
import {
    getColumnIdFromBinId as resolveColumnIdFromBinId,
    isRestrictedByColumnMapping as isColumnRestrictedByMapping,
    isBinRestrictedForUser,
    getColumnRestrictionHighlightStyle,
    shouldShowRestrictionLock,
} from './columnRestriction';

let nums = Array.from(Array(3).keys());
let nums1 = Array.from(Array(12).keys());
let elem = ['A', 'B', 'C'];
let deactivatedBin = [];
let IsSaved;
let BinIds = [];

export class Main24Layout extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillReceiveProps() {
        const { deactivatedBins } = this.props;
        if (deactivatedBins && deactivatedBins.length > 0) {
            deactivatedBins.map((item) => {
                return true
            })
        }
        else {
            deactivatedBin.map((item) => {
                return true
            })
            deactivatedBin = [];
        }
    }

    checkIsSaved = (binId) => {
        const { BinStatus } = this.props;
        if (BinStatus && BinStatus.length && BinStatus.length > 0) {
            BinStatus.map((binitem) => {
                if (binitem.bin_id === binId) {
                    IsSaved = true;
                }
                else {
                    IsSaved = false;
                }
                return true;
            })
        }
        else {
            IsSaved = false;
        }
    }

    getColumnIdFromBinId = (binId) => resolveColumnIdFromBinId(binId);

    isRestrictedByColumnMapping = (binId) =>
        isColumnRestrictedByMapping(
            binId,
            this.props.columnMappings,
            this.props.userGroupType
        );

    isRestricted = (groupTypeId, binId) =>
        isBinRestrictedForUser({
            binId,
            userGroupType: this.props.userGroupType,
            columnMappings: this.props.columnMappings,
            occupiedGroupTypeId: groupTypeId,
        });

    getColumnRestrictionStyle = (binId) =>
        getColumnRestrictionHighlightStyle(
            binId,
            this.props.columnMappings,
            this.props.userGroupType
        );

    renderBinLabel = (binId, label, occupiedGroupTypeId = null) => [
        shouldShowRestrictionLock({
            binId,
            userGroupType: this.props.userGroupType,
            columnMappings: this.props.columnMappings,
            occupiedGroupTypeId,
        }) ? <LockIcon key={`${binId}-lock`} fontSize='12px' /> : null,
        <span key={`${binId}-label`}>&nbsp;{label}</span>,
    ];

    // Helper method to handle bin click with restriction check
    handleBinClick = (binId, groupTypeId, status, pm_id) => {
        // Double-check restriction before opening
        if (this.isRestricted(groupTypeId, binId)) {
            console.log('[Main24] Click blocked - bin is restricted:', binId);
            return false; // Return false to indicate click should be blocked
        }
        this.openbin(binId, status, pm_id);
        return true;
    };

    openbin = (binId, status, pm_id) => {
        // Check if bin is restricted by column mapping - don't allow opening if restricted
        if (this.isRestrictedByColumnMapping(binId)) {
            console.log('[Main24] openbin blocked - bin is restricted by column mapping:', binId);
            return; // Don't allow opening if restricted by column mapping
        }
        
        // Also check combined restriction (group type + column mapping)
        if (this.isRestricted(null, binId)) {
            console.log('[Main24] openbin blocked - bin is restricted (combined check):', binId);
            return;
        }
        
        if (status === 'Assigned' || status === 'Stocked' || status === 'Hold') {
            this.props.getPrescriptionDetails(binId, pm_id);
        }
        else {
            // Handle deactivated bins without status - allow activation
            if (this.props.deactivatedBins && this.props.deactivatedBins.includes(binId)) {
                this.props.Selectedbin(binId);
                this.props.getPrescriptionDetails(binId, pm_id);
                let items = document.getElementById(binId);
                if (items) {
                    items.style.background = '#f87171';
                    items.style.color = '#ffffff';
                }
            } else {
                BinIds.map((item) => {
                    this.checkIsSaved(item);
                    if (item !== binId && IsSaved === false) {
                        var items = document.getElementById(item);
                        items.style.background = '#f8fafc';
                        items.style.color = '#334155';
                        items.style.border = '1px solid #cbd5e1';
                    }
                    return true
                })
                BinIds = [];
                BinIds.push(binId);
                if (BinIds.length > 0) {
                    this.props.Selectedbin(binId);
                    var items = document.getElementById(binId);
                    items.style.background = '#fbbf24';
                    items.style.color = '#422006';
                    items.style.border = '1px solid #f59e0b';
                }
            }
        }
    }

    render() {
        const BoxStatus = {
            ASSIGNED: '8f9c8e02-b9ee-4f29-aeea-670cef022663',
            STOCKED: '4ee90c0f-d4c3-4d53-8014-d7eac4ea2894',
            HOLD: '45593c2c-fc8c-4bf0-854e-e2bf759b7788',
            PICKED_UP: '00fe15e3-80b9-4e6f-9bf3-ad0c09a58c3e',
            CANCELLED: '8a994741-402e-4b18-a883-60da7fc94c7b',
            RETURNED: '198473ec-2e3f-42c8-a3f9-a0a3f8b4ae55',
            DEACTIVATED: '4f666da5-bfe0-4fb5-ad77-b92103881220'
        }
        const { classes, BinStatus, deactivatedBins, t, isViewPermissionAllowed, ADAData, PatientID} = this.props;
        return (
            <div className={classes.unitFrame}>
                <div
                    className={classes.m24Grid}
                    style={{ pointerEvents: isViewPermissionAllowed ? 'auto' : 'none' }}
                >
                    <div className={classes.m24DisplayPanel} aria-hidden="true">
                        <div className={classes.kioskDisplayInner}>
                            <span>SCREEN</span>
                        </div>
                    </div>
                {nums1.map((n1) => {
                    let doorInx = n1 + 1;
                    const isdisabledDoor = Array.isArray(ADAData) && ADAData.some(function (item) {
                        return (
                            item &&
                            item.patient_id === PatientID &&
                            item.ada_compitible === true &&
                            ![7, 8, 9].includes(doorInx)
                        );
                    });
                    return nums.map((n) => {
                                if ((elem[n] === 'A' || elem[n] === 'B') && (n1 >= 0 && n1 <= 5)) {
                                    return null;
                                }
                                if (elem[n] === 'A' || elem[n] === 'B' || elem[n] === 'C') {
                                        if (BinStatus && BinStatus.length && BinStatus.length > 0) {
                                            let BinKey = elem[n] + (n1 + 1)
                                            for (var i = 0; i < BinStatus.length; i++) {
                                                let pm_id = BinStatus[i].id;
                                                let isLockedBin = BinStatus[i].is_locked;
                                                if (BinStatus[i].type_id === BoxStatus.STOCKED && BinStatus[i].bin_id === BinKey) {
                                                    return (
                                                        <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title={t("Global.Prescriptions.Status.Stocked")}>
                                                            <div
                                                                style={{ gridColumn: n + 1, gridRow: n1 + 1,  
                                                                    padding: 0,
                                                                    pointerEvents: this.isRestricted(BinStatus[i] && BinStatus[i].group_type_id, elem[n] + '' + (n1 + 1)) ? 'none' : (isViewPermissionAllowed ? 'auto' : 'none'), 
                                                                    cursor: this.isRestricted(BinStatus[i] && BinStatus[i].group_type_id, elem[n] + '' + (n1 + 1)) ? 'not-allowed' : (isViewPermissionAllowed ? 'pointer' : 'not-allowed')
                                                                }}
                                                                // eslint-disable-next-line no-loop-func
                                                                onClick={(e) => {
                                                                    const binId = elem[n] + '' + (n1 + 1);
                                                                    const groupTypeId = BinStatus[i] && BinStatus[i].group_type_id;
                                                                    if (!this.handleBinClick(binId, groupTypeId, 'Stocked', pm_id)) {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                    }
                                                                }}
                                                                key={((elem[n] + ' ' + (n1 + 1)))}
                                                                className={isdisabledDoor ? classes.disabledDoor : classes.kioskDoor}
                                                            >
                                                                <Paper
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        ...this.getColumnRestrictionStyle(BinKey),
                                                                    }}
                                                                    id={elem[n] + '' + (n1 + 1)} 
                                                                    className={isLockedBin ? classes.gridPurpleBin : classes.gridOrangeback}
                                                                >
                                                                    {this.renderBinLabel(BinKey, `${elem[n]} ${n1 + 1}`, BinStatus[i] && BinStatus[i].group_type_id)}
                                                                </Paper>
                                                            </div>
                                                        </Tooltip>
                                                    );
                                                }
                                                else if (BinStatus[i].type_id === BoxStatus.ASSIGNED && BinStatus[i].bin_id === BinKey) {
                                                    return (
                                                        <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title={t("Global.Prescriptions.Status.Assigned")}>
                                                            <div
                                                                style={{ gridColumn: n + 1, gridRow: n1 + 1,  
                                                                    padding: 0, 
                                                                    pointerEvents: this.isRestricted(BinStatus[i] && BinStatus[i].group_type_id, elem[n] + '' + (n1 + 1)) ? 'none' : (isViewPermissionAllowed ? 'auto' : 'none'),
                                                                    cursor: this.isRestricted(BinStatus[i] && BinStatus[i].group_type_id, elem[n] + '' + (n1 + 1)) ? 'not-allowed' : (isViewPermissionAllowed ? 'pointer' : 'not-allowed')
                                                                }}
                                                                // eslint-disable-next-line no-loop-func
                                                                onClick={(e) => {
                                                                    const binId = elem[n] + '' + (n1 + 1);
                                                                    const groupTypeId = BinStatus[i] && BinStatus[i].group_type_id;
                                                                    if (!this.handleBinClick(binId, groupTypeId, 'Assigned', pm_id)) {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                    }
                                                                }}
                                                                key={((elem[n] + ' ' + (n1 + 1)))}
                                                                className={isdisabledDoor ? classes.disabledDoor : classes.kioskDoor}
                                                            >
                                                                <Paper
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        ...this.getColumnRestrictionStyle(BinKey),
                                                                    }} 
                                                                    id={elem[n] + '' + (n1 + 1)} 
                                                                    className={isLockedBin ? classes.gridPurpleBin : classes.gridBlueback}
                                                                >
                                                                    {this.renderBinLabel(BinKey, `${elem[n]} ${n1 + 1}`, BinStatus[i] && BinStatus[i].group_type_id)}
                                                                </Paper>
                                                            </div>
                                                        </Tooltip>
                                                    );
                                                }
                                                else if (BinStatus[i].type_id === BoxStatus.HOLD && BinStatus[i].bin_id === BinKey) {
                                                    return (
                                                        <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title={t("Global.Prescriptions.Status.Hold")}>
                                                            <div
                                                                style={{ gridColumn: n + 1, gridRow: n1 + 1,  
                                                                    padding: 0, 
                                                                    pointerEvents: this.isRestricted(BinStatus[i] && BinStatus[i].group_type_id, elem[n] + '' + (n1 + 1)) ? 'none' : (isViewPermissionAllowed ? 'auto' : 'none'),
                                                                    cursor: this.isRestricted(BinStatus[i] && BinStatus[i].group_type_id, elem[n] + '' + (n1 + 1)) ? 'not-allowed' : (isViewPermissionAllowed ? 'pointer' : 'not-allowed')
                                                                }}
                                                                // eslint-disable-next-line no-loop-func
                                                                onClick={(e) => {
                                                                    const binId = elem[n] + '' + (n1 + 1);
                                                                    const groupTypeId = BinStatus[i] && BinStatus[i].group_type_id;
                                                                    if (!this.handleBinClick(binId, groupTypeId, 'Hold', pm_id)) {
                                                                        e.preventDefault();
                                                                        e.stopPropagation();
                                                                    }
                                                                }}
                                                                key={((elem[n] + ' ' + (n1 + 1)))}
                                                                className={isdisabledDoor ? classes.disabledDoor : classes.kioskDoor}
                                                            >
                                                                <Paper
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        justifyContent: 'center',
                                                                        ...this.getColumnRestrictionStyle(BinKey),
                                                                    }} 
                                                                    id={elem[n] + '' + (n1 + 1)} 
                                                                    className={isLockedBin ? classes.gridPurpleBin : classes.gridSkyblueback}
                                                                >
                                                                    {this.renderBinLabel(BinKey, `${elem[n]} ${n1 + 1}`, BinStatus[i] && BinStatus[i].group_type_id)}
                                                                </Paper>
                                                            </div>
                                                        </Tooltip>
                                                    );
                                                }
                                            }
                                            if (deactivatedBins && deactivatedBins.length && deactivatedBins.length > 0 && deactivatedBins.findIndex(D => D === (elem[n] + (n1 + 1))) > -1) {
                                                const deactivatedBinKey = elem[n] + '' + (n1 + 1);
                                                return (
                                                    <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title="DEACTIVATE">
                                                        <div
                                                            className={isdisabledDoor ? classes.disabledDoor : classes.kioskDoor}
                                                            style={{ gridColumn: n + 1, gridRow: n1 + 1,  
                                                                padding: 0, 
                                                                pointerEvents: this.isRestricted(BinStatus[i] && BinStatus[i].group_type_id, elem[n] + '' + (n1 + 1)) ? 'none' : (isViewPermissionAllowed ? 'auto' : 'none'),
                                                                cursor: this.isRestricted(BinStatus[i] && BinStatus[i].group_type_id, elem[n] + '' + (n1 + 1)) ? 'not-allowed' : (isViewPermissionAllowed ? 'pointer' : 'not-allowed')
                                                            }}
                                                            onClick={() => this.openbin(deactivatedBinKey)}
                                                            key={elem[n] + ' ' + (n1 + 1)}
                                                        >
                                                            <Paper
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    ...this.getColumnRestrictionStyle(deactivatedBinKey),
                                                                }} 
                                                                id={deactivatedBinKey} 
                                                                className={classes.gridRedback}
                                                            >
                                                                {this.renderBinLabel(deactivatedBinKey, `${elem[n]} ${n1 + 1}`, BinStatus[i] && BinStatus[i].group_type_id)}
                                                            </Paper>
                                                        </div>
                                                    </Tooltip>
                                                );
                                            } else {
                                                return (
                                                    <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title={t("Global.Prescriptions.Status.Available")}>
                                                        <div
                                                            style={{ gridColumn: n + 1, gridRow: n1 + 1,  
                                                                padding: 0, 
                                                                pointerEvents: this.isRestricted(BinStatus[i] && BinStatus[i].group_type_id, elem[n] + '' + (n1 + 1)) ? 'none' : (isViewPermissionAllowed ? 'auto' : 'none'),
                                                                cursor: this.isRestricted(BinStatus[i] && BinStatus[i].group_type_id, elem[n] + '' + (n1 + 1)) ? 'not-allowed' : (isViewPermissionAllowed ? 'pointer' : 'not-allowed')
                                                            }}
                                                            onClick={() =>this.openbin(elem[n] + '' + (n1 + 1))}
                                                            key={elem[n] + ' ' + (n1 + 1)}
                                                            className={isdisabledDoor ? classes.disabledDoor : classes.kioskDoor}
                                                        >
                                                            <Paper
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    ...this.getColumnRestrictionStyle(elem[n] + '' + (n1 + 1)),
                                                                }}
                                                                id={elem[n] + '' + (n1 + 1)} 
                                                                className={classes.gridback}
                                                            >
                                                                {this.renderBinLabel(elem[n] + '' + (n1 + 1), `${elem[n]} ${n1 + 1}`, BinStatus[i] && BinStatus[i].group_type_id)}
                                                            </Paper>
                                                        </div>
                                                    </Tooltip>
                                                );
                                            }
                                        } else {
                                            if (deactivatedBins.length > 0 && deactivatedBins.findIndex(D => D === (elem[n] + (n1 + 1))) > -1) {
                                                const deactivatedBinKey = elem[n] + '' + (n1 + 1);
                                                return (
                                                    <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title="DEACTIVATE">
                                                        <div
                                                            className={isdisabledDoor ? classes.disabledDoor : classes.kioskDoor}
                                                            style={{ gridColumn: n + 1, gridRow: n1 + 1,  
                                                                padding: 0, 
                                                                pointerEvents: this.isRestricted(BinStatus[i] && BinStatus[i].group_type_id, elem[n] + '' + (n1 + 1)) ? 'none' : (isViewPermissionAllowed ? 'auto' : 'none'),
                                                                cursor: this.isRestricted(BinStatus[i] && BinStatus[i].group_type_id, elem[n] + '' + (n1 + 1)) ? 'not-allowed' : (isViewPermissionAllowed ? 'pointer' : 'not-allowed')
                                                            }}
                                                            onClick={() => this.openbin(deactivatedBinKey)}
                                                            key={elem[n] + ' ' + (n1 + 1)}
                                                        >
                                                            <Paper
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    ...this.getColumnRestrictionStyle(deactivatedBinKey),
                                                                }}
                                                                id={deactivatedBinKey} 
                                                                className={classes.gridRedback}
                                                            >
                                                                {this.renderBinLabel(deactivatedBinKey, `${elem[n]} ${n1 + 1}`, BinStatus[i] && BinStatus[i].group_type_id)}
                                                            </Paper>
                                                        </div>
                                                    </Tooltip>
                                                );
                                            } else {
                                                return (
                                                    <Tooltip key={((elem[n] + ' ' + (n1 + 1)))} title={t("Global.Prescriptions.Status.Available")}>
                                                        <div
                                                            style={{ gridColumn: n + 1, gridRow: n1 + 1,  
                                                                padding: 0, 
                                                                pointerEvents: this.isRestricted(BinStatus[i] && BinStatus[i].group_type_id, elem[n] + '' + (n1 + 1)) ? 'none' : (isViewPermissionAllowed ? 'auto' : 'none'),
                                                                cursor: this.isRestricted(BinStatus[i] && BinStatus[i].group_type_id, elem[n] + '' + (n1 + 1)) ? 'not-allowed' : (isViewPermissionAllowed ? 'pointer' : 'not-allowed')
                                                            }}
                                                            onClick={() =>this.openbin(elem[n] + '' + (n1 + 1))}
                                                            key={elem[n] + ' ' + (n1 + 1)}
                                                            className={isdisabledDoor ? classes.disabledDoor : classes.kioskDoor}
                                                        >
                                                            <Paper
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    ...this.getColumnRestrictionStyle(elem[n] + '' + (n1 + 1)),
                                                                }}
                                                                id={elem[n] + '' + (n1 + 1)} 
                                                                className={classes.gridback}
                                                            >
                                                                {this.renderBinLabel(elem[n] + '' + (n1 + 1), `${elem[n]} ${n1 + 1}`, BinStatus[i] && BinStatus[i].group_type_id)}
                                                            </Paper>
                                                        </div>
                                                    </Tooltip>
                                                );
                                            }
                                        }
                                    }
                                return null;
                            });
                })}
            </div>
            </div>
        );
    }
};

export default withStyles(styles)(withTranslation()(Main24Layout));



// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/Main24-layout.js